import React from "react";
import {Image, View, TouchableOpacity} from "react-native";
import kiosk_logo_RGB_1row from "../assets/img/evenplay-logo-long.svg";
import MainStyle from "../../MainStyle";
import button_exit from "../assets/img/icons/button_exit.png";
import {useSafeAreaInsets} from "react-native-safe-area-context";
import HelpLinkModalTrigger from "../modals/HelpLinksModal";
import Div from "../lib/Div";
import {colors} from "../assets/styles/colors";
import P from "../lib/P";

type Props = { title: string, onExit: () => void };

const SupportGuideHeader = (props: Props) => {
  const {title} = props;
  const insets = useSafeAreaInsets();

  return (
    <>
      <Div row mb={34} mt={12} alignItems="center" justifyContent="center" pt={insets.top}>
        <Div w={28} h={28} mx={19}/>

        <Div flex={1}>
          <Image
            source={kiosk_logo_RGB_1row as any}
            style={[MainStyle.h_37, MainStyle.w_225, MainStyle.rm_stretch, MainStyle.m_x_auto]}
          />
        </Div>

        <View>
          <TouchableOpacity onPress={props.onExit}>
            <Image
              source={button_exit} style={[MainStyle.w_28, MainStyle.h_28, MainStyle.m_x_19, MainStyle.m_b_4]}
            />
          </TouchableOpacity>

          <HelpLinkModalTrigger size={28} mx={19} page="support_guide"/>
        </View>
      </Div>

      <P lh={28} ta="center" tt="uppercase" mb={2}>Support Guide and FAQ</P>

      <Div row mb={18} alignItems="center" justifyContent="center">
        <P fw="700" fs={20} lh={32} ta="center" tt="uppercase" color={colors.lightBlue} flex={1}>{title}</P>
      </Div>

      <Div h={2} bg={colors.blueText}/>
    </>
  );
};

export default React.memo(SupportGuideHeader);
